// extracted by mini-css-extract-plugin
export var deliveryRow = "_sn-a";
export var fixedHeight = "_sn-4";
export var freightLogo = "_sn-9";
export var fullWidth = "_sn-3";
export var priceColumn = "_sn-5";
export var radioSelected = "_sn-7";
export var radioUnselected = "_sn-6";
export var selectedOption = "_sn-2";
export var selectedOptionContainer = "_sn-1";
export var selection = "_sn-0";
export var tallSkeletonText = "_sn-8";